import React from 'react'
import { Formik, Form } from 'formik'
import { validateResetPasswordForm } from './validation'
import { routes } from 'app/routes'
import { Card } from 'app/components/ui/Card'
import { Text } from 'app/components/ui/Text'
import { Button } from 'app/components/ui/Button'
import styled from 'styled-components'
import { SmartInput } from 'app/components/formik/Input'
import { Link } from 'react-router-dom'
import { GetDataError } from 'restful-react'
import { ApiError } from 'EstraSuppliers'
import { ApiErrorMessage } from 'app/components/ui/form/ApiErrorMessage'
import { Title } from 'app/components/ui/Title'
import { themeEstra } from 'app/styles/themeEstra'

const initialValues = {
  password: '',
  passwordConfirmation: '',
}

export type ResetPasswordFormValues = {
  password: string
  passwordConfirmation: string
}

interface Props {
  onResetPasswordRequest: (
    password: string,
    setSubmitting: (isSubmitting: boolean) => void
  ) => void
  isLoading: boolean
  showConfirmation: boolean
  error?: GetDataError<ApiError> | null
}
export const FormResetPassword: React.FC<Props> = ({
  onResetPasswordRequest,
  isLoading,
  showConfirmation,
  error,
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validate={validateResetPasswordForm}
      onSubmit={({ password }, { setSubmitting }) => {
        onResetPasswordRequest(password, setSubmitting)
      }}
    >
      {() => {
        return (
          <Form>
            <Card shadow padding='2rem'>
              {showConfirmation ? (
                <>
                  <ConfirmationTitle size={4}>
                    La nuova password è stata impostata.
                  </ConfirmationTitle>
                  <LoginConfirmationLinkWrapper>
                    <Link to={routes.login.makeUrl()}>Accedi al Servizio</Link>
                  </LoginConfirmationLinkWrapper>
                </>
              ) : (
                <>
                  <InputGroup>
                    <SmartInput
                      label='Password'
                      name='password'
                      type={'password'}
                      bgColor={themeEstra.color.neutri.grigioBg}
                    ></SmartInput>
                    <Text variant='s14' mt={0.5}>
                      Almeno 8 caratteri, 1 maiuscola, 1 numero ed 1 carattere
                      speciale (!#?@)
                    </Text>
                  </InputGroup>
                  <InputGroup>
                    <SmartInput
                      label='Conferma Password'
                      name='passwordConfirmation'
                      type={'password'}
                      bgColor={themeEstra.color.neutri.grigioBg}
                    ></SmartInput>
                  </InputGroup>
                  <Link to={routes.login.makeUrl()}>Torna indietro</Link>
                </>
              )}
              {!showConfirmation && (
                <ButtonWrapper>
                  {error && (
                    <>
                      <ResetPasswordApiErrorMessage
                        error={error}
                        outline
                      ></ResetPasswordApiErrorMessage>
                      <Link to={routes.forgotPassword.makeUrl()}>
                        Richiedi nuovo link
                      </Link>
                    </>
                  )}
                  <Button size='lg' type='submit' disabled={isLoading}>
                    Imposta password
                  </Button>
                </ButtonWrapper>
              )}
            </Card>
          </Form>
        )
      }}
    </Formik>
  )
}

const InputGroup = styled.div`
  margin-bottom: 2rem;
`

const LoginConfirmationLinkWrapper = styled.div`
  text-align: center;
`

const ButtonWrapper = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ResetPasswordApiErrorMessage = styled(ApiErrorMessage)`
  margin-bottom: 1rem;
`

const ConfirmationTitle = styled(Title)`
  margin-bottom: 1rem;
`
